<ng-container>
  <div
    class="input-label-field input-label-field--spacingBottom-{{
      spacingBottom
    }} input--{{ direction }}"
    [ngClass]="{
      'input--hasError': error,
      'input--hasLabel': !!label,
      'input--hasErrorMessage': !!errorMessage
    }"
  >
    @if(label) {
    <label class="input-label input-label--base {{ labelSize }}" [for]="id">
      {{ label }}
    </label>
    }
    <div class="input-wrapper">
      @if (type === InputType.DESCRIPTION) {
      <textarea
        [id]="id"
        class="input--base input--description input--width-{{ width }} input--{{
          variant
        }} input--error-{{ error }}"
        [attr.data-test-id]="testId"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [(ngModel)]="value"
        [ngClass]="{ 'input--disabled': disabled }"
      ></textarea>
      } @else {
      <input
        class="input--base input--size-{{ size }} input--width-{{
          width
        }} input--{{ variant }} input--error-{{ error }} input--{{ type }}"
        type="{{ type }}"
        [ngClass]="{ 'input--disabled': disabled }"
        autocomplete="off"
        [disabled]="disabled"
        [attr.placeholder]="placeholder"
        [attr.data-test-id]="testId"
        [(ngModel)]="value"
      />
      @if (type === InputType.SEARCH) {
      <svg
        class="input--search-icon"
        viewBox="0 0 16 16"
        fill="#4d5154"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.16667 1C10.5724 1 13.3333 3.76091 13.3333 7.16667C13.3333 8.5723 12.863 9.86809 12.0712 10.9053C12.1022 10.9278 12.1324 10.9539 12.1611 10.9826L14.7538 13.5753C15.0793 13.9007 15.0793 14.4284 14.7538 14.7538C14.4284 15.0793 13.9007 15.0793 13.5753 14.7538L10.9826 12.1611C10.9539 12.1324 10.9278 12.1022 10.9042 12.0707C9.86809 12.863 8.5723 13.3333 7.16667 13.3333C3.76091 13.3333 1 10.5724 1 7.16667C1 3.76091 3.76091 1 7.16667 1ZM7.16667 2.66667C4.68139 2.66667 2.66667 4.68139 2.66667 7.16667C2.66667 9.65195 4.68139 11.6667 7.16667 11.6667C9.65195 11.6667 11.6667 9.65195 11.6667 7.16667C11.6667 4.68139 9.65195 2.66667 7.16667 2.66667Z"
          fill="#4D5154"
        />
      </svg>
      } @if ((type === InputType.TEXT && showPassword() === true) || (type ===
      InputType.PASSWORD && showPassword() === false)) {
      <button
        (click)="togglePassword()"
        class="input--password-icon"
        type="button"
      >
        @if (showPassword()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#5f6368"
        >
          <path
            d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
          />
        </svg>
        } @if (!showPassword()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 -960 960 960"
          width="24px"
          fill="#5f6368"
        >
          <path
            d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
          />
        </svg>
        }
      </button>
      } }
    </div>
    @if (error && errorMessage) {
    <p class="input--error-text">
      {{ errorMessage }}
    </p>
    }
  </div>
</ng-container>
